import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useCartContext } from '../../hooks/contexts/cart.context';
import { ListView, useUiContext } from '../../hooks/contexts/ui.context';
import BulletQuantity from '../BulletQuantity';
import * as Style from './session-card.style';

type SessionCardProps = {
  id?: number;
  title: string;
  weekAndHour?: string | null;
  finished: boolean;
  hasTicketAvailable: boolean;
  definitiveSessionId: string;
  status?: string | string[];
}

const SessionCard: FC<SessionCardProps> = ({
  title,
  id,
  weekAndHour,
  finished,
  hasTicketAvailable,
  definitiveSessionId,
  status
}) => {
  const { handleChangeListView } = useUiContext();
  const { ticketsPerSession } = useCartContext();
  const disabled = finished || !hasTicketAvailable || status === 'soldout';

  return (
    <Style.SessionCard
      $marginBottom="0"
      $disabled={disabled}
      onClick={() => {
        if (disabled) return;
        handleChangeListView(ListView.TICKETS, id);
      }}
    >
      <Style.MainText
        $disabled={disabled} id="session-card-title"
      >
        {title}
        {Boolean(ticketsPerSession[definitiveSessionId]) && (
          <BulletQuantity
            quantity={ticketsPerSession[definitiveSessionId]}
          />
        )}
      </Style.MainText>
      <p>{weekAndHour}</p>
      <Style.ArrowRight
        $disabled={disabled}
        src={ImagesApp.svg.arrowRight}
        alt="forward arrow"
      />
    </Style.SessionCard>
  );
};

export default SessionCard;
